import { createSlice } from '@reduxjs/toolkit';
import { LocalStorageService } from 'services';
import { AppConstants } from 'constants/index';

const initialState = {
  configs: { pageSize: AppConstants.pageSize, languageId: AppConstants.defaultLanguage, ...LocalStorageService.get('configs') },
  current: LocalStorageService.get('current') || {},
};
const slice = createSlice({
  name: 'userPreferences',
  initialState,
  reducers: {
    saveUserConfigs: (state, action) => {
      state.configs = action.payload;
    },
    saveUserConfigKey: (state, action) => {
      const { key, configValue } = action.payload;
      state.configs[key] = configValue;
    },
    setCurrentBrandId: (state, action) => {
      state.current.brandId = action.payload;
    },
    setCurrentPartnerId: (state, action) => {
      state.current.partnerId = action.payload;
    },
    setCurrentConversionId: (state, action) => {
      state.current.conversionId = action.payload;
    },
  },
});
export const {
  saveUserConfigs, saveUserConfigKey, setCurrentBrandId, setCurrentPartnerId, setCurrentConversionId,
} = slice.actions;
export default slice.reducer;
